export const defaultHeight = '75vh';
